import { memo } from 'react';
import PropTypes from 'prop-types';
import FightFilters from './FightFilters';

const FlightFilterBar = ({ tripId }) => (
  <div className="text-theme border-b-2 pb-2">
    <div className="flex flex-wrap gap-2">
      <FightFilters tripId={tripId} />
    </div>
  </div>
);

FlightFilterBar.propTypes = {
  tripId: PropTypes.string.isRequired,
};

export default memo(FlightFilterBar);
